import { Component } from '@angular/core';
import { canValidateMappings$, CanValidateMappingsComponent } from './can-validate-mappings.component';
import { MappingsService } from './mappings.service';
import { Observable, of, switchMap } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { EaccessAuthService } from '../auth/eaccess-auth.service';

@Component({
  selector: 'eaa-mappings-home-card',
  imports: [AsyncPipe, CanValidateMappingsComponent, RouterLink],
  template: `
    <eaa-can-validate-mappings>
      <div class="card" style="min-width: 300px;">
        <div class="card-header">
          <h4 class="card-title m-0">MAPPINGS TO CHECK</h4>
        </div>
        <div class="card-body">
          <strong>{{ mappingsToCheckoutCount$ | async }}</strong> mapping(s) pending validation
        </div>
        <div class="card-footer d-flex justify-content-end">
          <a class="btn btn-outline-primary" [routerLink]="['/mappings', 'pending-check']">VIEW</a>
        </div>
      </div>
    </eaa-can-validate-mappings>
  `
})
export class MappingsHomeCardComponent {
  public mappingsToCheckoutCount$: Observable<number> | null = null;

  constructor(
    private mappingsService: MappingsService,
    private authService: EaccessAuthService
  ) {}

  public ngOnInit(): void {
    this.mappingsToCheckoutCount$ = canValidateMappings$(this.authService).pipe(
      switchMap((canValidate) => (canValidate ? this.mappingsService.countMappingsPendingCheck$() : of(0)))
    );
  }
}
